<template>
  <etg-select v-if="isSelectMode" v-model:value="value" class="filter-item-select" :options="props.options" :show-checkmark="false" />
  <bottom-drawer
    v-else
    :title="$t('sorting.title')"
    :is-action-shown="false"
    :is-footer-shown="true"
    :submitLabel="$t('general.confirm')"
    @submit="handleDrawerSubmit"
    @close="handleDrawerClose"
  >
    <template #trigger="{ open }">
      <etg-button class="sm:-mr-3" icon="sorting" size="small" @click="handleDrawerOpen(open)">{{ selectedOption?.name }}</etg-button>
    </template>
    <etg-radio-group v-model="selectorValue" :options="radioOptions" />
  </bottom-drawer>
</template>

<script setup lang="ts">
import BottomDrawer from '@/components/common/bottom-drawer.vue'
import EtgRadioGroup from '@/components/form/etg-radio-group.vue'

interface Props {
  mode?: 'select' | 'icon'
  options?: {
    label: string
    value: string | number
  }[]
}

const value = defineModel<string>()

const props = withDefaults(defineProps<Props>(), {
  mode: 'select',
  options: () => [],
})

// drawer
const selectorValue = ref('')
const isSelectMode = computed(() => props.mode === 'select')
const radioOptions = computed(() => props.options.map(option => ({ name: option.label, id: option.value })))
const selectedOption = computed(() => radioOptions.value.find(opt => opt.id === value.value))

const handleDrawerOpen = (cb: () => void) => {
  selectorValue.value = value.value || ''
  cb()
}

const handleDrawerSubmit = () => {
  value.value = selectorValue.value
}

const handleDrawerClose = () => {
  selectorValue.value = value.value || ''
}
</script>
